import { Injectable } from '@angular/core';
import { TableApiService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/services/table-api.service';
import { ITaxonAbundanceCategory } from '../interfaces/taxon-abundance-category.interface';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'apps/mba-cpr-survey-portal/src/environments/environment';
import { lastValueFrom } from 'rxjs';
import { ITaxon } from '../../taxon/taxon.interface';
import { IMeasurement } from '../../measurement/measurement.interface';
import { getAbundance } from '@cpr/shared/abundance';

type PickMeasurement = Pick<IMeasurement, '_id' | 'analysedCount' | 'taxonAbundanceCategoryId'>;
type PickTaxon = Pick<ITaxon, 'taxonName' | 'cprTaxonId' | 'countingMethod'> & {
  taxonChildren?: PickTaxon[];
} & {
  measurement?: PickMeasurement;
};

@Injectable({ providedIn: 'root' })
export class TaxonAbundanceCategoryService {
  private categories = null;

  constructor(
    private http: HttpClient,
    private readonly dialog: MatDialog,
  ) {}

  async refreshHierarchy() {
    this.categories = null;

    await this.loadAll();
  }

  private async loadAll() {
    if (!this.categories) {
      this.categories = await lastValueFrom(
        this.http.get<ITaxonAbundanceCategory[]>(`${environment.cprServiceApi}category`),
      );
    }
  }

  async getCategories(): Promise<ITaxonAbundanceCategory[]> {
    if (!this.categories) {
      await this.loadAll();
    }

    return this.categories;
  }

  async getCategoryById(categoryId: string): Promise<ITaxonAbundanceCategory> {
    if (!this.categories) {
      await this.loadAll();
    }

    return this.categories.find((c) => c._id == categoryId);
  }

  async evaluateCategory(
    analysedCount: number | '+',
    countingMethod: 'EYECOUNT' | 'TRAVERSE' | 'PHYTO',
    factor: number,
    taxonAbundanceCategoryId?: string,
    dividePhytoByTwo = false,
  ) {
    if (analysedCount) {
      return getAbundance(analysedCount, countingMethod, factor, dividePhytoByTwo);
    } else if (taxonAbundanceCategoryId) {
      return (await this.getCategoryById(taxonAbundanceCategoryId))?.taxonCategory;
    }
  }
}
